module.exports = __webpack_public_path__ + "img/int8_rel_esc_01.562507cf.jpg";